import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-event-log-window',
    templateUrl: './event-log-window.component.html',
    styleUrls: ['./event-log-window.component.scss'],
    standalone: false
})
export class EventLogWindowComponent implements OnInit {
  @Input() public rows: [];
  @Input() public columns: [];

  constructor() { }

  ngOnInit(): void {
  }

}
